export const addFieldPrefix = (field: string): string => `field--${field}`;
export const removeFieldPrefix = (field: string): string => field.replace(/^field--/, '');
